module.exports = __webpack_public_path__ + "media/images/social/youtube-e5c50bff797469bd1a4d6defb473f40a.png";